import {IPlaybackControlState} from "./IPlaybackControlStateTypes";
import {NotationLayoutEnum} from "../../../models/view/lessonPage/NotationLayoutEnum";
import {getUserPreferencesForControlBar} from "../../UserPreferencesForControlBarService";

export const createPlaybackControlState = (options: IPlaybackControlState = getPlaybackControlStateDefaults()): IPlaybackControlState => {
  const state: IPlaybackControlState = Object.assign({}, options);

  const persistedZoom = getUserPreferencesForControlBar().zoomAmount;
  state.zoom = persistedZoom ? persistedZoom : options.zoom; // On construction, initialize with persisted zoom if available.
  return state;
}

export const getPlaybackControlStateDefaults = (): IPlaybackControlState => ({
  // This overrides settings.getDefaultUserPreferencesForControlBar().demoMode
  // which, if imported here causes circular import issues.
  appliedNotationLayout: NotationLayoutEnum.vertical,
  demoMode: 'both hands',
  hidePlayheadDuringPlayback: false,
  isCountInPlaying: false,
  isCurrentMeasureHighlighted: false,
  isDemoLeftHandSoundEnabled: false,
  isDemoRightHandSoundEnabled: false,
  isInstantFeedbackEnabled: true,
  isLoopEnabled: false,
  isLoopingEnabled: false,
  isPlaybackEnabled: false,
  isPlaying: false,
  notationSpacing: {
    spacingForActiveLesson: undefined,
    lessonSpacing: [],
  },
  pageCount: 0,
  selectedNotationLayout: NotationLayoutEnum.auto,
  speed: 1,
  tempo: 119,
  zoom: 0,
});
